export default __webpack_public_path__ + "static/media/MiniTape_SideA_02_Telefonbeantworter-Familie-Müller.5be4516d.mp3";